(() => {
 const mobile = window.matchMedia('(max-width: 768px)');
 function initialise(root = document) {
   root.querySelectorAll('.lt-filter-panel').forEach(panel => {
     if (panel.dataset.leksMobileReady) return;
     panel.dataset.leksMobileReady = 'true';
     panel.open = !mobile.matches;
     mobile.addEventListener('change', () => { panel.open = !mobile.matches; });
   });
 }
 initialise();
 document.addEventListener('shopify:section:load', event => initialise(event.target));
 const visible = new Set();
 const observer = new IntersectionObserver(entries => {
   entries.forEach(entry => { if(entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
   document.body.classList.toggle('leks-purchase-visible', visible.size > 0);
 });
 function observe(root = document) {
   root.querySelectorAll('.variant-wrapper,.product-single__form,[data-store-availability-holder]').forEach(element => observer.observe(element));
 }
 observe();
 document.addEventListener('shopify:section:load', event => observe(event.target));
 document.addEventListener('shopify:section:unload', event => {
   event.target.querySelectorAll('.variant-wrapper,.product-single__form,[data-store-availability-holder]').forEach(element => { observer.unobserve(element); visible.delete(element); });
   document.body.classList.toggle('leks-purchase-visible', visible.size > 0);
 });
})();
